<template>
  <div v-show="viewedIntro" class="main-container">
    <portal
      v-if="
        isMobile &&
          viewedIntro &&
          isAssessmentAcceleratorActivity &&
          !isAssessmentAcceleratorTesterActivity &&
          assessmentAcceleratorModuleProgress
      "
      to="mobile-activity-header"
    >
      <div id="mobile-portal-header"></div>
    </portal>

    <portal
      v-if="
        viewedIntro && isAssessmentAcceleratorActivity && !isAssessmentAcceleratorTesterActivity
      "
      to="save-activity-button"
    >
      <save-activity-button></save-activity-button>
    </portal>

    <portal
      v-if="
        viewedIntro &&
          isAssessmentAcceleratorActivity &&
          !isAssessmentAcceleratorTesterActivity &&
          assessmentAcceleratorModuleProgress
      "
      to="activity-progress-bar"
    >
      <activity-progress-bar
        :currentActivity="assessmentAcceleratorModuleProgress.currentActivity"
        :totalActivities="assessmentAcceleratorModuleProgress.totalActivities"
      ></activity-progress-bar>
    </portal>

    <h2
      v-if="instructions && instructions.written"
      ref="instructions"
      class="activity-instructions"
    >
      {{ instructions.written }}
    </h2>
    <div :class="{ 'component-container': isAssessmentAcceleratorActivity, tablet: isMobile }">
      <component :is="activity" class="activity-template" ref="activity">
        <component :is="keyboardComponent" slot="keyboard"></component>
      </component>
    </div>

    <portal
      v-if="viewedIntro && isAssessmentAcceleratorActivity && !hasCustomNextButton"
      to="next-activity-button"
    >
      <next-activity-button :on-click="handleOnActivitySubmit"></next-activity-button>
    </portal>
  </div>
</template>

<script>
import { TimelineLite } from 'gsap';
import { mapState, mapGetters } from 'vuex';
import { createAudio } from 'utils/audio-util';
import StandardKeyboard from '../keyboards/StandardKeyboard.vue';
import ExternalKeyboard from '../keyboards/ExternalKeyboard.vue';
import MobileOnscreenKeyboard from '../keyboards/MobileOnscreenKeyboard.vue';
import ActivityProgressBar from './ActivityProgressBar.vue';
import NextActivityButton from './NextActivityButton.vue';
import SaveActivityButton from './SaveActivityButton.vue';

export default {
  components: {
    ActivityProgressBar,
    ExternalKeyboard,
    MobileOnscreenKeyboard,
    NextActivityButton,
    SaveActivityButton,
    StandardKeyboard
  },
  computed: {
    ...mapState('application', ['device']),
    ...mapState('activity', [
      'keepInstructionsOnScreen',
      'progress',
      'instructions',
      'viewedIntro',
      'data',
      'dataLoaded',
      'readyToStart'
    ]),
    ...mapGetters('activity', [
      'assessmentAcceleratorModuleProgress',
      'activityInProgress',
      'activityTitle',
      'isAssessmentAcceleratorActivity',
      'hasCustomNextButton'
    ]),
    ...mapGetters('activity/typing', ['isTouchHold']),
    ...mapGetters('application', ['needsToChooseKeyboard']),

    ...mapState('keyboard', {
      isTouchHold: ({ settings: { isTouchHold } = {} }) => isTouchHold
    }),
    ...mapState('application', {
      isMobile: state => state.device.isMobile,
      kwtMode: state => state.kwtMode
    }),
    ...mapGetters('application', ['usingExternalKeyboard']),

    activity() {
      const { activityTitle: { name: activityTitle } = {} } = this;

      return () => import(`@/activities/${activityTitle}.vue`);
    },

    keyboardComponent() {
      const { isMobile, usingExternalKeyboard } = this;
      let name = 'StandardKeyboard';
      if (isMobile) {
        name = usingExternalKeyboard ? 'ExternalKeyboard' : 'MobileOnscreenKeyboard';
      }

      return name;
    },

    isAssessmentAcceleratorTesterActivity() {
      return !!(
        this.isAssessmentAcceleratorActivity &&
        (this.kwtMode === 'tester' || ['preview', 'previewLite'].includes(this.kwtMode))
      );
    }
  },

  // mounted() {
  //   if (
  //     this.needsToChooseKeyboard &&
  //     this.dataLoaded &&
  //     (this.isAssessmentAcceleratorActivity ||
  //       (!this.isAssessmentAcceleratorActivity && this.data.keyboard) ||
  //       (this.isAssessmentAcceleratorTesterActivity && this.data.keyboard))
  //   ) {
  //     const query = { return: this.$router.app._route.path }; // eslint-disable-line
  //     this.$router.replace({ path: '/keyboard-select', query });
  //   }
  // },

  methods: {
    handleOnActivitySubmit() {
      this.$refs.activity.handleOnActivitySubmit();
    }
  },

  watch: {
    extKeyAttemptEvent(newEvent) {
      this.handleKeyDown(newEvent);
    },

    activityInProgress(newInProgress, oldInProgress) {
      if (!oldInProgress && newInProgress && this.$refs.instructions) {
        const timeline = new TimelineLite();
        const { keepInstructionsOnScreen } = this;
        timeline.fromTo(this.$refs.instructions, 1, { autoAlpha: 0 }, { autoAlpha: 1 });

        if (!keepInstructionsOnScreen && this.instructions.delay) {
          // hear it type it keeps instructions on screen
          timeline.to(this.$refs.instructions, 0.5, { autoAlpha: 0 }, this.instructions.delay);
        }
        return true;
      }

      return newInProgress;
    },

    voiceInstructions(path) {
      if (path) {
        this.voiceIntro = createAudio(path, { html5: !this.device.isMobile });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-template {
  height: 100%;
}

.main-container {
  height: 100%;
  position: relative;
}

.activity-instructions {
  font-family: 'hwtfutura';
  margin: 10px 0;
  font-size: 18px;
  position: fixed;
  top: 0;
  left: 1.5%;
  z-index: 10;
  -webkit-font-smoothing: auto;

  &.white-bg {
    background-color: white;
    border-radius: 5px;
  }
}

.component-container {
  margin-top: 70px;
  height: 100%;

  &:not(.tablet) {
    margin-top: 0px;
  }
}

#mobile-portal-header {
  background-color: #ffffff;
  height: 70px;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}
</style>
